import { Theme } from "@mui/material/styles";

export const SizeStyles = (theme: Theme) => {
  return {
    sm: {
      padding: `${theme.space._100} ${theme.space._300}`,
      gap: theme.space._150,

      ".MuiChip-label": {
        fontSize: theme.fontSizes.xs,
      },

      ".MuiChip-deleteIcon" : {
        width: "16px",
        height: "16px",
      },
    },
    md: {
      padding: `${theme.space._150} ${theme.space._300}`,
      gap: theme.space._200,

      ".MuiChip-label": {
        fontSize: theme.fontSizes.sm,
      },

     
    },
    lg: {
      padding: `${theme.space._200} ${theme.space._400}`,
      gap: theme.space._300,

      ".MuiChip-label": {
        fontSize: theme.fontSizes.md,
      },

      ".MuiChip-deleteIcon" : {
        width: "24px",
        height: "24px",
      },
      
    },
  };
};
